import { flatten, uniq, get, chunk } from "lodash";
import Papa from "papaparse";
import teamService from "@irati/identity/services/teams";
import userService from "@irati/identity/services/users";
import { promiseSerialAll } from "@irati/utils/promise";
var addUsersToTeamByCSV = function (file, formatMessage, tenantUuid, teamUuid) {
    return new Promise(function (resolve) {
        Papa.parse(file, {
            header: false,
            skipEmptyLines: true,
            complete: function (results) {
                var failedUsers = [];
                var saved = false;
                var chunks = chunk(uniq(flatten(results.data)));
                var funcs = chunks.map(function (userChunk) { return function () {
                    return Promise.all(userChunk.map(function (email) {
                        return userService.getUserByEmail(email, tenantUuid)
                            .then(function (user) {
                            if (user) {
                                return teamService.addUserToTeam(teamUuid, user.uuid).then(function () {
                                    saved = true;
                                });
                            }
                            failedUsers.push({
                                email: email,
                                message: formatMessage({ id: "platform.addBulkUsersToTeam.errors.userDoesNotExist" })
                            });
                        })
                            .catch(function (err) {
                            var message = get(err, "response.data.message", formatMessage({ id: "platform.addBulkUsersToTeam.errors.default" }));
                            failedUsers.push({
                                email: email,
                                message: message
                            });
                        });
                    }));
                }; });
                return promiseSerialAll(funcs).then(function () { return resolve({ saved: saved, failedUsers: failedUsers }); });
            }
        });
    });
};
export default addUsersToTeamByCSV;
